import "features/reports/testReport/components/SchoolTestReport.css";
import {capitalize} from "utils/functions";
import {ReportLeftBottom, ReportLeftBottomXs, ReportSegmentsImage} from "features/reports/testReport/utils/reportsFunctions";
import CoverPage from "../shared/CoverPage";
import moment from "moment";
import Chart from "../shared/Chart";
import AboutSection from "./AboutSection";
import ChartSubsection from "../shared/ChartSubsection";
import ChartNoteWrapperBig from "../shared/ChartNoteWrapperBig";
import TableRow from "../shared/TableRow";
import MarkGroup from "../shared/MarkGroup";
import Units from "../shared/Units";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {useEffect, useState} from "react";
import ScrollBar from "../../../../../shared/ui/ScrollBar";

const Report = ({reportSummary, gradeLevels, graphData}: any) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.up("sm"));
    const [left, setLeft] = useState(0);
    const [bottom, setBottom] = useState(0);
    const segmentsImage = ReportSegmentsImage(reportSummary.score, "numericLiteracy");

    useEffect(() => {
        if (isSmallScreen) {
            setLeft(ReportLeftBottom(reportSummary.score, "school")[0]);
            setBottom(ReportLeftBottom(reportSummary.score, "school")[1]);
        } else {
            setLeft(ReportLeftBottomXs(reportSummary.score, "school")[0]);
            setBottom(ReportLeftBottomXs(reportSummary.score, "school")[1]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div className="cover-bg">
                <div id="print_page" className="wrapper-cover">
                    <CoverPage coverImage={reportSummary.coverImage} type="school">
                        <>
                            <div className="title">
                                <h1>Testul Național de Alfabetizare Matematică</h1>
                                <h2>Sesiune #{reportSummary.testId}</h2>
                                <h1>Scor {reportSummary.score}</h1>
                            </div>
                            <h2> {reportSummary.studentName && `Elev: ${reportSummary.studentName}`}</h2>
                            <h2>
                                {reportSummary.testTitle !== null ? capitalize(reportSummary.testTitle) : ""}
                                {" "}
                                {reportSummary.testGradeName === "I" || reportSummary.testGradeName === "0" ?
                                    `clasa ${reportSummary.testGradeName}` : `clasa a ${reportSummary.testGradeName}-a`} |{" "}
                                {moment(reportSummary.testStartedAt).locale("ro").format("DD MMMM YYYY")}
                            </h2>
                        </>
                    </CoverPage>

                    <div className="pagebreak"></div>

                    <AboutSection/>

                    <div className="pagebreak"></div>

                    <div className="section-despre">
                        <h1>Scorul global</h1>
                        <Chart
                            testMode={reportSummary.testModeId}
                            left={left}
                            bottom={bottom}
                            testScore={reportSummary.score}
                            segmentsImage={segmentsImage}
                            big={true}
                            type="numericLiteracy"
                        />
                        {gradeLevels.map((gradeLevel: any, index: any) => (
                            <div key={index}>
                                <ChartSubsection gradeLevel={gradeLevel} score={reportSummary.score} index={index}
                                                 type="numericLiteracy"/>
                            </div>
                        ))}
                    </div>

                    <div className="pagebreak"></div>
                    {graphData.length > 0 && (
                        graphData.map((section: any, index: any) => (
                            <div key={index} className="section-despre" style={{marginTop: "50px"}}>
                                <h2>Componenta {index + 1}: {section.name}</h2>
                                <p>Medie scor: {section.score}</p>
                                <ScrollBar forceVisible="x" autoHide={false}>
                                    <table className="tabel-note">
                                        <thead>
                                        <tr>
                                            <th className="col-capitol">&nbsp;</th>
                                            <th className="col-values">
                                                <Units type="numericLiteracy"/>
                                                <MarkGroup type="numericLiteracy"/>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody key={index}>
                                        <TableRow section={section} index={index} type="numericLiteracy"/>
                                        </tbody>
                                        <tfoot>
                                        <tr className="legenda">
                                            <td>&nbsp;</td>
                                            <td className="col-legend">
                                                <img src="/images/reports/chart-tabel-numeratie.png"
                                                     className="chart-tabel" alt=""/>
                                                <Units type="numericLiteracy"/>
                                                <ChartNoteWrapperBig big={false} type="numericLiteracy"/>
                                            </td>
                                        </tr>
                                        </tfoot>
                                    </table>
                                </ScrollBar>
                                <div key={index}>
                                    <div dangerouslySetInnerHTML={{__html: section.subcategoriesDescription[index]}}/>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </>
    );
};

export default Report;
